import { useEffect } from "react";
//context
import { useGlobalContext } from "../../../contexts";
//apollo
import client from '../../../src/utils/apollo/client';
//queries
import { GET_PAGE } from "../../../src/queries/pages/get-page";
//routing
import {handleRedirectsAndReturnData} from '../../../src/utils/slug';
//components
import Layout from "../../../src/components/layout"

const Compare = ( { data } ) => {
  const { context, setContext } = useGlobalContext();


  useEffect(() => {
    if (!context.isSet) {
      data.context.options.isSet = true;
      setContext(data.context.options);
    }
  }, []);

	return (
    <Layout
      logos={data?.logos?.options?.logos}
      mainMenu={data?.mainMenu?.edges}
      menuFooter={data?.menuFooter?.edges}
      seo={data?.content?.seo}
      breadcrumbs={data?.content?.seo?.breadcrumbs}
      content={data?.content}
      pt_key={process.env.PAGE_PT_KEY}
      templateWhite={data?.content?.acfSidebar?.bgWhite}
      comparatorDatas={data?.comparatorDatas?.nodes}
      optionsFooter={data?.content?.acfSidebar?.optionsFooter}
    >
    </Layout>
	);
};

export default Compare;

export async function getStaticProps(context) {
	const { data, errors } = await client.query( {
		query: GET_PAGE(process.env.PAGE_PT_KEY),
    variables: {
      uri: '/comparer/'
    }
	});

	const defaultProps = {
		props: {
			data: data || {}
		},
		revalidate: 60,
	};

	const result = handleRedirectsAndReturnData( defaultProps, data, errors, { allowNotFound: false } );

  data.content.seo.breadcrumbs.splice(data.content.seo.breadcrumbs.length - 1, 0, {
    text: 'Nos produits',
    url: '/nos-produits/'
  });
  data.content.seo.breadcrumbs.splice(data.content.seo.breadcrumbs.length - 1, 0, {
    text: 'Nos fauteuils',
    url: '/nos-produits/nos-fauteuils-massants/'
  });

	return result;
}